export const GET_SERVICE_APPLICATION = gql`
    query retrieveMerchantServiceApplication($merchantAccountNumber: String!) {
        retrieveMerchantServiceApplication(merchantAccountNumber: $merchantAccountNumber) {
            id
            status
            businessInformation
            merchantInformation
            partnerId
            partnerOfPartnerId
            serviceRequirements
            outletInformation
            supportingDocuments
            terminalId
            authorId
            mid
            isServiceApplication
            worldpayPO
            merchantAccountNumber
            tradingName
            partner {
                firstName
                lastName
                business {
                    legalName
                }
            }
            partnerOfPartner {
                firstName
                lastName
                business {
                    legalName
                }
            }
            adobeSignJobs {
                jobId
                principalSignatureIndex
            }
        }
    }
`;
